module.exports = __webpack_public_path__ + "img/top-restaurant-bg.42add85.jpg";